import React from 'react';

import ZoomControl from '@ui/zoomControl/ZoomControl.tsx';

import { widgetEnum } from '../../../../utils/constants.ts';

function create(app) {
  const init = () => {};
  const handleKeyboardSelect = event => {
    if (event.key !== 'Enter' && event.key !== ' ') {
      return;
    }

    const zoomControl = event.target.closest('[data-testid="ZoomControl"]');
    if (!zoomControl) {
      return;
    }

    const zoomInButton = zoomControl.querySelector('[name="zoom.in"]').closest('button');
    const zoomOutButton = zoomControl.querySelector('[name="zoom.out"]').closest('button');

    if (event.target === zoomInButton) {
      app.bus.send('map/zoomIn', { userInitiated: true });
    } else if (event.target === zoomOutButton) {
      app.bus.send('map/zoomOut', { userInitiated: true });
    }
  };

  app.bus.send('layers/register', {
    id: 'mapZoom',
    widget: () => (
      <ZoomControl
        onKeyDown={handleKeyboardSelect}
        data-testid="ZoomControl"
        onZoomIn={() => app.bus.send('map/zoomIn', { userInitiated: true })}
        onZoomOut={() => app.bus.send('map/zoomOut', { userInitiated: true })}
        zoomInTooltipContent={app.gt()('mapZoomOnline:Zoom In')}
        zoomOutTooltipContent={app.gt()('mapZoomOnline:Zoom Out')}
      />
    ),
    show: true,
    isOverlay: true,
    layoutId: 'buttonOptions',
    widgetType: widgetEnum.Desktop,
    order: 30,
  });

  return {
    init,
  };
}

export { create };
